var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { background: "transparent", border: "none" } },
    [
      _c(
        "w-card-title",
        {
          style: {
            padding: "0px 15px",
            borderBottom: "none",
            fontWeight: "bold",
            fontSize: "14px",
          },
        },
        [_vm._t("title")],
        2
      ),
      _c(
        "w-card-content",
        {
          style: { overflow: "hidden", paddingTop: "5px" },
          attrs: { "no-padding": "" },
        },
        _vm._l(_vm.userList, function (user, i) {
          return _c(
            "w-list-item",
            {
              key: i,
              class: { active: _vm.$route.params.userId == user.ID },
              attrs: { to: "/chat/user/" + user.ID },
            },
            [
              _c("w-list-item-text", [
                user.Unread > 0
                  ? _c("span", { staticClass: "unread" }, [
                      _vm._v(_vm._s(user.Unread)),
                    ])
                  : _vm._e(),
                _c("span", {
                  staticClass: "bullit",
                  class: { online: user.Online },
                }),
                _vm._v(" " + _vm._s(user.Firstname) + " "),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }